import { ErrorBoundary, useMonitoringClient } from '@xometry/ui';
import { ErrorPage } from 'pages';
import { FC, ReactNode, useCallback } from 'react';

import { isUnauthorizedApolloError } from './ErrorBoundary.utils';

interface Props {
  children: ReactNode;
}

export const ErrorBoundaryWrapper: FC<Props> = (props) => {
  const { children } = props;
  const client = useMonitoringClient();

  const handleError = useCallback(
    (error: Error) => {
      if (isUnauthorizedApolloError(error)) return;

      client.captureError(error);
    },
    [client],
  );

  return (
    <ErrorBoundary fallback={<ErrorPage />} onDidCatch={handleError}>
      {children}
    </ErrorBoundary>
  );
};
